import React, { Component } from 'react';
import css from './style.css';
import CSSModule from 'react-css-modules';
import { connect } from 'react-redux';

import { loginByCode, getUserInfo } from '../../actions';

import TextFeild from '../../component/textFeild';
import Title from '../../component/title';
import $ from 'jquery';
import { browserHistory } from 'react-router'
import Button from '../../component/button';

class Login extends Component {
	constructor(props) {
		super(props);
		//console.log(props);
		this.login = (e) => {

			let jsonData = {
				phoneNum: props.location.query.phone,
				code: props.location.query.pre + '-' + this.refs.input.state.data
			}

			props.loginByCode(jsonData).then(function(res){
                //console.log(res);
				if(res && res.id) {
					props.getUserInfo();
					browserHistory.push('/applyMain');
				}else {
					alert("唉呀，簡訊密碼錯了，再檢查看看。");
				}
                
            })
		}
		this.handleKeydown = (e) => {
			if( e.key === 'Enter') {
				this.login();
			}
		}
		this.back = (e) => {
			browserHistory.push('/home');
		}
	}
	render() {
		const hint = <p className="hint">電話號碼 { this.props.location.query.phone }<br/>
					  我們剛剛發送了一則簡訊到您的門號，<br/>
					  請收簡訊填寫您的密碼。</p> ;
		return (
			<div styleName="">
				<Title>驗證電話號碼</Title>
				{ hint }
				<div>{ this.props.location.query.pre }-<TextFeild styleName="input" ref="input" onKeyDown={this.handleKeydown}/></div>
				<Button styleName="button main" onClick={this.login}>驗證</Button>
				<Button styleName="button disabled" onClick={this.back}>再試一次</Button>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return state;
}

export default connect(mapStateToProps, { loginByCode, getUserInfo })(CSSModule(Login,css, {allowMultiple:true}));




/** WEBPACK FOOTER **
 ** ./src/container/login/index.js
 **/